export const rnds_index = ['rnds.index']
export const rnds_create = ['rnds.create']
export const rnds_show = ['rnds.show']
export const rnds_company_edit = ['rnds.company.edit']

export default [].concat(
    rnds_index,
    rnds_create,
    rnds_show,
    rnds_company_edit
)
